<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M7.09243 1.66797H12.9092C13.1029 1.66792 13.2514 1.66789 13.3813 1.68059C14.3044 1.7709 15.0601 2.32595 15.3805 3.07362H4.62109C4.94152 2.32595 5.69715 1.7709 6.62034 1.68059C6.75017 1.66789 6.8987 1.66792 7.09243 1.66797Z"
      fill="currentColor"
    />
    <path
      d="M5.2616 3.9375C4.10274 3.9375 3.15252 4.63729 2.83541 5.56566C2.82881 5.58501 2.82246 5.60447 2.81641 5.62401C3.1482 5.52353 3.49351 5.45789 3.84306 5.41308C4.74337 5.29766 5.88116 5.29772 7.20285 5.29779H7.30155H12.9462C14.2679 5.29772 15.4057 5.29766 16.3061 5.41308C16.6556 5.45789 17.0009 5.52353 17.3327 5.62401C17.3267 5.60447 17.3203 5.58501 17.3137 5.56566C16.9966 4.63729 16.0463 3.9375 14.8875 3.9375H5.2616Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.22829 6.28516H12.7743C15.5866 6.28516 16.9928 6.28516 17.7827 7.10751C18.5726 7.92987 18.3867 9.20037 18.0151 11.7415L17.6626 14.151C17.3711 16.1438 17.2254 17.1401 16.4777 17.7368C15.7301 18.3335 14.6273 18.3335 12.4218 18.3335H7.58077C5.37531 18.3335 4.27258 18.3335 3.52492 17.7368C2.77726 17.1401 2.63152 16.1438 2.34004 14.151L1.98756 11.7415C1.61587 9.20037 1.43003 7.92987 2.2199 7.10751C3.00978 6.28516 4.41595 6.28516 7.22829 6.28516ZM6.66797 15.0002C6.66797 14.655 6.97889 14.3752 7.36241 14.3752H12.6402C13.0237 14.3752 13.3346 14.655 13.3346 15.0002C13.3346 15.3455 13.0237 15.6253 12.6402 15.6253H7.36241C6.97889 15.6253 6.66797 15.3455 6.66797 15.0002Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TeamOverviewIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>